require('./media/js/gdpr');
require('./media/js/gdpr/banner');
